module.exports = __webpack_public_path__ + "img/add-apply.e2a8ea64.png";